import { usePlan } from "@/features/auth/hooks/usePlan";
import { useIsFeatureHidden } from "@/shared/hooks/useAppSettings";

const SPONSORSHIP_FEATURE_CODE = "service_sponsorship";

export const useHasSponsorshipAccess = (): boolean => {
  const plan = usePlan();
  const isHidden = useIsFeatureHidden(SPONSORSHIP_FEATURE_CODE);

  return !!plan?.features.service_sponsorship && !isHidden;
};
